import {
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  GET_UNREAD_COUNT_SUCCESS,
  POST_MARK_AS_READ_REQUEST,
  POST_MARK_AS_READ_SUCCESS,
  POST_MARK_AS_READ_FAILURE,
  POST_MARK_ALL_AS_READ_SUCCESS,
} from './notificationActionTypes';

const initialState = {
  isLoading: false,
  message: '',
  notifications: [],
  pagination: {},
  totalUnRead: 0,
  pendingReadId: null,
};

export default function notificationReducer(state = initialState, action) {
  const { type, payload, message } = action;

  switch (type) {
    case GET_NOTIFICATIONS_REQUEST:
      return { ...state, isLoading: true };
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notifications: payload.data,
        pagination: payload,
        // The list reports the unread total alongside the page.
        totalUnRead: payload.unread ?? state.totalUnRead,
      };
    case GET_NOTIFICATIONS_FAILURE:
      return { ...state, isLoading: false, message };

    case GET_UNREAD_COUNT_SUCCESS:
      return { ...state, totalUnRead: payload?.count ?? state.totalUnRead };

    case POST_MARK_AS_READ_REQUEST:
      return { ...state, pendingReadId: action.id };
    case POST_MARK_AS_READ_SUCCESS: {
      // Update the row in place rather than refetching the page.
      const wasUnread = state.notifications.some((n) => n.id === state.pendingReadId && !n.is_read);
      return {
        ...state,
        pendingReadId: null,
        notifications: state.notifications.map((n) => (n.id === state.pendingReadId ? { ...n, is_read: true } : n)),
        totalUnRead: wasUnread ? Math.max(state.totalUnRead - 1, 0) : state.totalUnRead,
      };
    }
    case POST_MARK_AS_READ_FAILURE:
      return { ...state, pendingReadId: null, message };

    case POST_MARK_ALL_AS_READ_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
        totalUnRead: 0,
      };

    default:
      return state;
  }
}
